var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgAffiliate = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M9 10.313a2.437 2.437 0 1 0 0-4.875 2.437 2.437 0 0 0 0 4.875Zm5.438-4.875a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-10.875 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM9 15.938a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm5.438-3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-10.875 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm9.659-8.123-2.25 1.631m2.251 4.197L11.04 9.21M9 12.938v-2.626m-4.181.304 2.14-1.406M4.778 4.815l2.25 1.631" }) }))); };
export default SvgAffiliate;
